/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_SourceInputs */

const es_admin_billing_bills_list_col_source = /** @type {(inputs: Admin_Billing_Bills_List_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origen`)
};

const en_admin_billing_bills_list_col_source = /** @type {(inputs: Admin_Billing_Bills_List_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Admin_Billing_Bills_List_Col_SourceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_source = /** @type {((inputs?: Admin_Billing_Bills_List_Col_SourceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_SourceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_source(inputs)
	return en_admin_billing_bills_list_col_source(inputs)
});
export { admin_billing_bills_list_col_source as "admin.billing.bills_list.col_source" }